export default __webpack_public_path__ + "static/media/MusicNoteBold.51807a28.svg";